import React from 'react';

import SectionA from '../sections/a.js';
import SectionB from '../sections/b.js';
import SectionC from '../sections/c.js';
import SectionD from '../sections/d.js';
import SectionE from '../sections/e.js';
import SectionF from '../sections/f.js';
import SectionG from '../sections/g.js';
import SectionH from '../sections/h.js';

export default function Step6(props){
    return <div className="seehi_step">
        <a name="seehiStep6" className="seehi_anchor" />
        <h2>Check of u in aanmerking komt voor deze subsidie</h2>
        <p>U ontdekt snel of u subsidie kunt krijgen met behulp van onderstaande vragen.</p>
        <SectionA />
        <SectionB />
        <SectionC />
        <SectionD />
        <SectionE />
        <SectionF />
        <SectionG />
        <SectionH />
    </div>;
}


// WEBPACK FOOTER //
// ./src/steps/step6.js